import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
} from 'reactstrap';

import EmptyStateImage from './components/Image';
import LearnMoreLink from './components/LearnMoreLink';
import UnlockButton from './components/UnlockButton';

import { userIsAdmin } from '../../helpers/Auth';
import { userHasFeature } from '../../helpers/Features';
import { getSetting } from '../../helpers/Settings';

const EmptyPeople = () => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Find your people, fast' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Automatically identify and tag the people in your photos, then let AI find them everywhere else. From team headshots to event photos, searching and filtering by people just got easier.' })}
        </div>
        {userHasFeature('face-recognition') ? (
          (!getSetting('face_recognition')) && (
            userIsAdmin() ? (
              <Button tag={Link} to="/admin/settings/ai-tagging" color="primary" className="mt-4">
                {intl.formatMessage({ defaultMessage: 'Enable Facial Recognition' })}
              </Button>
            ) : (
              <div className="mt-4">
                <strong>{intl.formatMessage({ defaultMessage: 'Facial Recognition can be enabled by a workspace admin' })}</strong>
              </div>
            )
          )
        ) : (
          <UnlockButton feature="face-recognition" />
        )}
        <LearnMoreLink
          url="https://help.stockpress.co/en/articles/12415334-facial-recognition"
          text={intl.formatMessage({ defaultMessage: 'Find out how' })}
        />
      </Col>
      <EmptyStateImage imageUrl="/images/empty-pages/empty-people-page.png" height="high" />
    </div>
  );
};

export default EmptyPeople;
